/* Upsell "Avra per Lui GRATIS" nel carrello.
   Aggiunge 1 unita' di per-Lui e applica il codice omaggio:
   il risultato e' identico ad "Acquista 1, Ricevi 1 OMAGGIO".
   Delegato su document -> sopravvive ai re-render del drawer. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lui-free-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var variantId = btn.getAttribute('data-variant');
    var code = btn.getAttribute('data-discount');
    var cartDrawer = document.querySelector('cart-drawer');
    var spinner = btn.querySelector('.loading__spinner');

    btn.disabled = true;
    btn.classList.add('loading');
    if (spinner) spinner.classList.remove('hidden');

    if (window.avraRecordAccentVariant) window.avraRecordAccentVariant(variantId);

    function restore() {
      btn.disabled = false;
      btn.classList.remove('loading');
      if (spinner) spinner.classList.add('hidden');
    }

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: 1, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (resp) {
      if (resp.status && resp.status >= 400) throw new Error('avra-add-error');
      // Nessuno sconto: usa subito le sezioni dell'add (1 richiesta)
      if (!code) return resp.sections || null;
      // Con sconto: applica il codice E ottieni le sezioni in UNA richiesta (2 totali)
      var sectionsPath = window.location.pathname + '?sections=cart-drawer,cart-icon-bubble';
      return fetch('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(sectionsPath), {
        method: 'GET',
        redirect: 'follow',
        credentials: 'same-origin',
        cache: 'no-store'
      }).then(function (r) { return r.json(); }).catch(function () { return resp.sections || null; });
    }).then(function (sections) {
      if (cartDrawer && typeof cartDrawer.renderContents === 'function' && sections) {
        cartDrawer.classList.remove('is-empty');
        cartDrawer.renderContents({ sections: sections });
      } else {
        restore();
      }
    }).catch(function () {
      restore();
    });
  });
})();
